import { Injectable } from '@angular/core';
import { List } from 'immutable';
import { DateTimeService, DAY_AS_SECONDS } from 'i2g-ng-utils';
import { ISelectOption } from '../select-field/select-field.interface';

@Injectable()
export class DurationPickerFieldBuilder {
  constructor(private _dateTimeService: DateTimeService) {}

  buildValues(secondsIncrement: number, format: string): List<ISelectOption> {
    const range = [];

    let seconds = 0;

    while (seconds <= DAY_AS_SECONDS) {
      range.push(seconds);

      seconds += secondsIncrement;
    }

    return List(range.map((value) => this.buildValue(value, format)));
  }

  buildValue(value: number, format: string): ISelectOption {
    return {
      key: this._dateTimeService.formatDuration(value, format),
      value,
    };
  }
}
